/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit InputFile.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-300.js"
import ButtonSolid from 'DesignSystem/ButtonSolid/view.js'
import CsvFileIcon from 'DesignSystem/Svgs/CsvFileIcon/view.js'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/view.js'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
borderBottomLeftRadius: 8,
borderBottomRightRadius: 8,
borderTopLeftRadius: 8,
borderTopRightRadius: 8,
  backgroundColor: 'var(--backgroundColor)',
marginRight: 'var(--marginRight)',
marginLeft: 'var(--marginLeft)',
marginBottom: 'var(--marginBottom)',
marginTop: 'var(--marginTop)',
height: 'var(--height)'})
styles.Capture = css({label: 'Capture',
  opacity: 0,
  height: 'var(--height)',
width: 'var(--width)'})
styles.Vertical1 = css({label: 'Vertical1',
  alignItems: "center",
justifyContent: "center",
flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
pointerEvents: "none",
position: "absolute",
width: "100%",
  height: 'var(--height)'})
styles.Subtext = css({label: 'Subtext',
  color: "#323232",
fontFamily: "WonderUnitSans",
fontSize: 14,
fontWeight: 300,
marginTop: 8})

export default function InputFile({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  backgroundColor= "#ffffff",
marginRight= 0,
marginLeft= 0,
marginBottom= 0,
marginTop= 0,
height= 160,
accept,
onChange,
width= "100%",
text,
subtext= ""
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="InputFile.Vertical"
 data-view-path={dataViewPath}
 style={{'--backgroundColor': backgroundColor,'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--marginBottom': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--marginTop': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--height': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Vertical}`}
>
<input
 type="file"
 data-testid="InputFile.Capture"
 data-view-path={dataViewPath}
 accept={accept}
 onChange={onChange}
 style={{'--height': typeof height === 'number' ? `${height}px` : height,'--width': typeof width === 'number' ? `${width}px` : width}}
 className={`views-capture ${styles.Capture}`}
/>
<div
 data-testid="InputFile.Vertical:1"
 data-view-path={dataViewPath}
 style={{'--height': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Vertical1}`}
>
<CsvFileIcon
 data-testid="InputFile.CsvFileIcon"
 data-view-path={dataViewPath}
 width={90}
 marginBottom={10}
/>
<SubTitle
 data-testid="InputFile.SubTitle"
 data-view-path={dataViewPath}
 text={text}
/>
<span
 data-testid="InputFile.Subtext"
 data-view-path={dataViewPath}
 className={`views-text ${styles.Subtext}`}
>
{subtext}
</span>
<ButtonSolid
 data-testid="InputFile.ButtonSolid"
 data-view-path={dataViewPath}
 paddingBottom={8}
 paddingLeft={16}
 paddingRight={16}
 paddingTop={8}
 marginTop={16}
 text="Upload"
/>
</div>
</div>
{children}
</React.Fragment>)
}